import { CommonModule } from '@angular/common';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TextEditModule } from 'NewAngular/features/components/modals/text-edit/text-edit.module';
import * as i0 from "@angular/core";
export class TalkingPointTextEditModalModule {
}
TalkingPointTextEditModalModule.ɵfac = function TalkingPointTextEditModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointTextEditModalModule)(); };
TalkingPointTextEditModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TalkingPointTextEditModalModule });
TalkingPointTextEditModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConfirmModalModule, ModalBaseModule, TextEditModule] });
